<template>
	<div class="flex justify-between">
		<div class="flex">
			<div class="box box-primary w-[4.5rem]"></div>
			<div class="box w-[6.25rem]"></div>
			<div class="box ml-05 w-[9rem]"></div>
		</div>

		<div class="flex gap-05">
			<div class="box w-[7rem]"></div>
			<div class="box w-[9rem]"></div>
			<div class="box w-[2rem]"></div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.box {
	@apply rounded-sm bg-level-02;
	height: 2rem;

	&-primary {
		@apply bg-primary;
	}
}
</style>
